export enum AccessRequestState {
    PendingApproval = 'PendingApproval',
    Approved = 'Approved',
    Denied = 'Denied'
}